module.exports = __webpack_public_path__ + "static/media/image-992.360db616.jpg";